//TODO: will remove this file and add dynamic data fetching for Filters Section Data
export const sampleSections = [
  {
    id: "medications",
    label: "Medications",
    options: [
      { label: "Painkillers", value: "painkillers" },
      { label: "Antibiotics", value: "antibiotics" },
      { label: "Antidepressants", value: "antidepressants" },
      { label: "Vaccines", value: "vaccines" },
      { label: "Insulin", value: "insulin" },
    ],
  },
  {
    id: "dosage",
    label: "Dosage",
    options: [
      { label: "1mg", value: "1mg" },
      { label: "5mg", value: "5mg" },
      { label: "10mg", value: "10mg" },
      { label: "20mg", value: "20mg" },
      { label: "50mg", value: "50mg" },
    ],
  },
  {
    id: "status",
    label: "Status",
    options: [
      { label: "Active", value: "active" },
      { label: "Inactive", value: "inactive" },
    ],
  },
];
